// A plan's invite link (08 §3, RP4): /plans/join/<code>. Signing in first comes back here; opening it
// joins the plan (friends or not yet), then opens it. While it works, a calm plate with the shape of
// a cover; if the link can't be used, it says why and where to go.
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { LinkButton } from "../../../components/Button";
import { EmptyState } from "../../../components/Empty";
import { Skeleton } from "../../../components/Skeleton";
import { Plate } from "../../../components/Surface";
import ui from "../../../components/ui.module.css";
import { useJoinPlan } from "../../../data/planQueries";
import { useTitle } from "../../../lib/useTitle";
import s from "./join.module.css";

export const Route = createFileRoute("/_app/plans/join/$code")({ component: Join });

function Join() {
  useTitle("Join a plan");
  const { code } = Route.useParams();
  const join = useJoinPlan();
  const navigate = useNavigate();
  const { mutate } = join;
  const asked = useRef(false);
  useEffect(() => {
    if (asked.current) return;
    asked.current = true;
    mutate(code, { onSuccess: (j) => void navigate({ to: "/plans/$journeyId", params: { journeyId: j.id }, replace: true }) });
  }, [mutate, code, navigate]);

  return (
    <div className={ui.page}>
      {join.isError ? (
        <EmptyState title={join.error.message}>
          <LinkButton to="/plans" variant="secondary">
            Go to Plans
          </LinkButton>
        </EmptyState>
      ) : (
        <Plate pad="lg" className={s.plate} role="status" aria-busy="true">
          <Skeleton width={72} height={115} shape="block" />
          <p className={s.words}>Opening the plan…</p>
          <p className={s.small}>You’ll read at your own pace, with the friends already reading it.</p>
        </Plate>
      )}
    </div>
  );
}
